export class Subscription
{
    private unsubscribeFn: () => void;

    constructor(unsubscribeFn: () => void)
    {
        this.unsubscribeFn = unsubscribeFn;
    }

    unsubscribe(): void
    {
        this.unsubscribeFn();
    }
}